import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import Theme18OfferLink from '@/components/Theme-18/components/Theme18OfferLink'
import { getBaseImageUrl, getMerchantHref } from '@/constants/hooks'
import { OffersMerchant, OffersOffer } from '@/services/dataTypes'

interface Props {
    data: OffersOffer
    merchant?: OffersMerchant
    height?: number
    width?: number
    offerLink?: string | null
    mer_slug?: string
    slug_type?: string
    domain: string
    unoptimized?: boolean
}

const Banner = ({ data, height, width, offerLink, mer_slug, slug_type, domain, unoptimized = false }: Props) => {
    const { offer_title, offer_detail, banner_image, url, coupon_code, unique_id } = data?.offer ?? {}

    const img = (
        <Image
            src={getBaseImageUrl(domain, banner_image, '')}
            alt={offer_title || offer_detail || 'banner'}
            className="object-contain rounded-xl"
            loading="lazy"
            height={height || 200}
            width={width || 300}
            unoptimized={unoptimized}
        />
    )

    return (
        <div className="w-full flex items-center justify-center overflow-hidden">
            {mer_slug && slug_type ? (
                <Theme18OfferLink
                    outUrl={offerLink || url}
                    unique_id={unique_id}
                    merchantHref={getMerchantHref(data?.merchant, mer_slug, slug_type)}
                    domain={domain}
                    couponCode={coupon_code || undefined}
                >
                    {img}
                </Theme18OfferLink>
            ) : (
                <Link href={offerLink || url} rel="nofollow sponsored noopener noreferrer" className="flex items-center justify-center w-full">
                    {img}
                </Link>
            )}
        </div>
    )
}

export default Banner
